module.exports = __webpack_public_path__ + "img/forest_natural_ba_detail_rsh.661e191e.jpg";